<template>
  <div
    :class="{
      'daily-game-box-shadow sticky self-start z-3 top-[52px] w-full bg-[#F7F8FB] py-4 px-6': isMobile && isCompactMode,
      'sm:sticky sm:top-[130px]': !cancelSticky,
    }"
    class="mb-5 sm:z-2"
  >
    <div v-if="!isMobile && !isSidebar" class="flex sm:mt-10 u-center justify-start mb-10">
      <p class="text-black text-[19px] font-semibold leading-28">Günün Oyunu</p>
    </div>
    <div
      v-if="!isMobile || (isMobile && !isCompactMode)"
      class="flex flex-col pt-8 px-4 pb-4 items-center rounded-xl border-[3px] bg-white shrink-0 relative mt-8 w-[327px]"
      :class="{ 'sm:w-[300px]': isSidebar }"
      style="border-color: rgba(0, 0, 0, 0.08)"
    >
      <OImage loading="lazy" src="/images/game/BilpopLogo.png" class="justify-start absolute left-4 -top-5 w-30 h-[46px]" />

      <p class="absolute right-[18px] top-[11px] text-[#1D1D1D] leading-20 font-medium text-md">#{{ paddedNumber }}</p>
      <div
        class="
          relative
          px-2
          py-3
          self-stretch
          rounded-md
          bg-[#480D83]
          border-2 border-[#2EB887]
          text-[#FF9513] text-sm
          font-medium
          leading-16
          u-center
          mt-2
          mb-4
        "
      >
        <OIcon class="absolute -top-2.5 left-[42px] text-[#F7F8FB]" icon="UnionTop" />
        <p>{{ game.question }}</p>
      </div>
      <div class="w-full mb-4">
        <div v-if="playerStatus && playerStatus.gameStatus === 'done'" class="flex flex-col items-center">
          <div class="flex justify-around w-[124px]">
            <span
              v-for="(i, index) in sortedChecklist"
              :key="index"
              class="w-6 h-6 text-24 font-semibold leading-22"
              :class="{ 'opacity-50': !i && playerStatus.gameStatus === 'done' }"
            >
              {{ playerStatus.gameStatus === 'done' || i ? '⭐' : '?' }}
            </span>
          </div>
          <div class="u-center text-md leading-5 font-normal mt-3 text-[#1D1D1D]">
            <div class="font-bold">{{ playerStatus.score }} puan</div>
          </div>
        </div>
        <div v-else class="flex flex-col">
          <div class="flex justify-around mx-auto w-[124px]">
            <div v-if="playerStatus && playerStatus.gameStatus !== 'in progress'">
              <span
                v-for="i in 5"
                :key="i"
                class="text-22 font-semibold leading-22 text-transparent bg-clip-text bg-gradient-to-r from-[#00084D] to-[#2C4389]"
              >
                ?
              </span>
            </div>
            <div v-else>
              <span v-for="(i, index) in sortedChecklist" :key="index" class="w-6 h-6 text-24 font-semibold leading-22">
                {{ playerStatus.gameStatus === 'done' || i ? '⭐' : '?' }}
              </span>
            </div>
          </div>
          <div class="flex justify-between text-md font-bold mt-3 text-[#1D1D1D]">
            <p class="font-medium">Günün Sorusu</p>
            <p>{{ playerStatus ? 'Oyununu bitir!' : 'Oyna, öğren!' }}</p>
          </div>
        </div>
      </div>

      <a
        :class="{
          'bg-[#2EB887]': !playerStatus,
          'bg-[#F3940E]': playerStatus && playerStatus.gameStatus === 'done',
          'bg-[#4D8EFF]': playerStatus && playerStatus.gameStatus === 'in progress',
        }"
        class="text-white text-base font-semibold rounded-md u-center py-2 px-4 h-[40px] self-stretch"
        :href="`${isWebview ? '/mobile' : ''}/bilpop`"
        @click="handleClickPlay"
      >
        {{ playerStatus ? (playerStatus.gameStatus === 'done' ? 'Oynandı' : 'Devam Et') : 'Oyna' }}
      </a>
    </div>
    <a
      v-if="isMobile && isCompactMode"
      class="flex h-11 pr-4 pl-2 justify-between items-center rounded-lg"
      :class="{
        'bg-[#2EB887]': !playerStatus,
        'bg-[#F3940E]': playerStatus && playerStatus.gameStatus === 'done',
        'bg-[#4D8EFF]': playerStatus && playerStatus.gameStatus === 'in progress',
      }"
      :href="`${isWebview ? '/mobile' : ''}/bilpop`"
    >
      <OImage loading="lazy" src="/images/game/BilpopLogo.png" class="w-[90px] h-[34.5px]" />
      <p class="text-white text-center text-base font-bold leading-22">
        Günün Sorusu:
        <span>{{ playerStatus ? (playerStatus.gameStatus === 'done' ? 'Oynandı' : 'Devam Et') : 'Oyna' }}</span>
      </p>
    </a>
  </div>
</template>
<script>
import {
  computed,
  defineComponent,
  ref,
  onMounted,
  onBeforeUnmount,
  useContext,
  useAsync,
  ssrRef,
  useRoute,
} from '@nuxtjs/composition-api';
import { throttle } from 'lodash';
import { useDevice } from '~/composables/useDevice';
import { useAuth } from '~/modules/auth/state/useAuth';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { OImage, OIcon } from '~/modules/common/components/ui';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';

export default defineComponent({
  components: { OImage, OIcon },
  setup(props) {
    const { sendKesfetEvent } = onedioEvents();
    const { isMobile } = useDevice();
    const route = useRoute();
    const isWebview = route.value?.path.includes('/mobile/oyun/');
    const game = ssrRef({});
    const playerStatus = ssrRef(null);
    const isCompactMode = ref(false);
    const scrollPosition = ref(0);
    const { $service } = useContext();
    const { isLoggedIn, user } = useAuth();
    const handleScroll = throttle(() => {
      scrollPosition.value = window.scrollY || document.documentElement.scrollTop;
      if (isMobile.value && scrollPosition.value >= 328 && !props.isSidebar) {
        isCompactMode.value = true;
      } else if (scrollPosition.value < 128) {
        isCompactMode.value = false;
      }
    }, 100);

    onMounted(() => {
      window.addEventListener('scroll', handleScroll);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('scroll', handleScroll);
    });
    const paddedNumber = computed(() => {
      return String(game.value.gameNumber).padStart(4, '0');
    });

    useAsync(async () => {
      try {
        const userParams = isLoggedIn.value ? { withStatuses: true, playerId: user.value._id } : {};
        const { data } = await $service.game.getDailyQuestion({ gameType: 'bilpop', ...userParams });
        game.value = data;
        if (process.client) {
          setLocalGameData();
        } else if (game.value.playerStatus) {
          playerStatus.value = game.value.playerStatus;
        }
      } catch (err) {
        console.log(err);
      }
    });

    const setLocalGameData = () => {
      if (isLoggedIn.value) return;
      const data = localStore.getItem('o-bilpop')?.[game.value.id];
      if (!data) return;
      const status = data.gameStatus === '' ? 'in progress' : data.gameStatus;
      playerStatus.value = {};
      playerStatus.value.statusData = data;
      playerStatus.value.gameStatus = status;
      playerStatus.value.score = data.score;
    };

    const sortedChecklist = computed(() => playerStatus.value?.statusData?.checkList?.sort().reverse());

    const handleClickPlay = () => {
      if (props.isSidebar) {
        sendKesfetEvent('Sidebar', 'Click', 'Bilpop');
      }
    };

    return { paddedNumber, isMobile, isCompactMode, game, playerStatus, sortedChecklist, isWebview, handleClickPlay };
  },
  props: {
    cancelSticky: {
      default: false,
      type: Boolean,
    },
    isSidebar: {
      default: false,
      type: Boolean,
    },
  },
});
</script>
<style scoped lang="scss">
.daily-game-box-shadow {
  box-shadow: 0px 4px 55px 0px rgba(0, 0, 0, 0.12);
}
</style>
